<section [class]="getContainerClasses()">
  <div class="p-card-body">
    <div class="widget-content">
      <ng-content select="[widget-content]"></ng-content>
    </div>
  </div>

  <ng-content select="[widget-footer]"></ng-content>

</section>
